var map = {
	"./404.svg": 17568,
	"./application.svg": 94650,
	"./back.svg": 40873,
	"./bug.svg": 26454,
	"./business.svg": 84534,
	"./calibration.svg": 2692,
	"./camera.svg": 36333,
	"./car.svg": 86586,
	"./chart.svg": 56136,
	"./clipboard.svg": 48906,
	"./collect.svg": 6350,
	"./command.svg": 41459,
	"./component.svg": 99181,
	"./dashboard.svg": 86468,
	"./data.svg": 35800,
	"./debug.svg": 24741,
	"./device.svg": 63542,
	"./documentation.svg": 83614,
	"./drag.svg": 32542,
	"./dustbin.svg": 15815,
	"./email.svg": 21272,
	"./example.svg": 63370,
	"./excel.svg": 84681,
	"./exit.svg": 97984,
	"./exit_full_screen.svg": 80431,
	"./eye.svg": 60191,
	"./farm.svg": 20532,
	"./farminfo.svg": 79624,
	"./form.svg": 31794,
	"./format.svg": 5713,
	"./full_screen.svg": 54254,
	"./history.svg": 62984,
	"./icon.svg": 67435,
	"./international.svg": 33020,
	"./job.svg": 22209,
	"./key.svg": 84189,
	"./language.svg": 73718,
	"./layout.svg": 20562,
	"./left.svg": 45995,
	"./location.svg": 2885,
	"./lock.svg": 44773,
	"./log.svg": 31886,
	"./maintance.svg": 63844,
	"./market.svg": 6488,
	"./message.svg": 36149,
	"./messagew.svg": 88944,
	"./money.svg": 44244,
	"./password.svg": 42739,
	"./people.svg": 73873,
	"./peoples.svg": 75744,
	"./pig.svg": 55940,
	"./plan.svg": 5601,
	"./processing.svg": 29841,
	"./product.svg": 32941,
	"./qq.svg": 162,
	"./record.svg": 31887,
	"./register.svg": 20499,
	"./report.svg": 47942,
	"./right.svg": 66478,
	"./robot.svg": 44712,
	"./search.svg": 73548,
	"./secret.svg": 9148,
	"./sensor.svg": 74234,
	"./shoppingCard.svg": 39206,
	"./sms.svg": 26519,
	"./star.svg": 70224,
	"./switch.svg": 77980,
	"./tab.svg": 73981,
	"./table.svg": 52756,
	"./tentacle.svg": 43626,
	"./terminal.svg": 74040,
	"./theme.svg": 12911,
	"./today.svg": 23755,
	"./track.svg": 48837,
	"./user.svg": 54225,
	"./userright.svg": 96357,
	"./users.svg": 89824,
	"./validcode.svg": 68429,
	"./video.svg": 66481,
	"./video_source.svg": 83419,
	"./wechat.svg": 62226,
	"./weight.svg": 20400,
	"./zip.svg": 98925
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;